export const DELETE_PROCESS_STATEMENT_SUCCESS = 'DELETE_PROCESS_STATEMENT_SUCCESS';

export const deleteProcessStatementSuccess = (id) => ({
    type: DELETE_PROCESS_STATEMENT_SUCCESS,
    payload: { id },
});
